export const TEST_ID = 'cartLineItem';

export const MIN_QUANTITY = 1;
